import {FACTIONS} from "../../../constants/factions";

export const GIANTS_QUOTES = [{
  quote: 'Чем я больше, тем меньше вопросов: "а что, если я наступлю?"',
  author: 'Стурм Мерщик, великан-старейшина клана Считающих локтей',
  factionId: FACTIONS.GIANTS
}, {
  quote: 'Крепостные стены — для меня лишь пороги на входе в ваш дом',
  author: 'Брогир Растущий, легендарный великан, дотянувшийся до облаков',
  factionId: FACTIONS.GIANTS
}, {
  quote: 'Они верили, что всему есть предел',
  author: 'Грим Трескун, великан, растоптавший Друбадильскую рощу',
  factionId: FACTIONS.GIANTS
}, {
  quote: 'Каждый день я становлюсь выше. А вы становитесь старше',
  author: 'Бьорн Широкий, великан-стяжатель высокогорных пастбищ Харсвота',
  factionId: FACTIONS.GIANTS
}, {
  quote: 'Я просто иду. Если ты оказался у меня под ногой — это не моя проблема',
  author: 'Хроар Утесовласый, прародитель великанов Белой горы',
  factionId: FACTIONS.GIANTS
}, {
  quote: 'Они строят стены выше. Я расту выше. Им придётся строить вечно',
  author: 'Тюр Толкающий, великан из легенд, сдвинувший горизонт',
  factionId: FACTIONS.GIANTS
}, {
  quote: 'Почему я вообще должен задумываться о твоем существовании?',
  author: 'Корд Сплюснутый, самый широкий великан Завывающих степей',
  factionId: FACTIONS.GIANTS
}, {
  quote: 'Если я случайно наступлю на город — это не жестокость. Это неосторожность. Но результат тот же',
  author: 'Сигр Невероятная, Та, кто была холмом',
  factionId: FACTIONS.GIANTS
}]